module.exports = __webpack_public_path__ + "static/amerRedCross-b85c649e08006ccb15bd8b28c712383f.png";